import { BaseWebComponentRepository } from '../../../../../framework/BaseWebComponentRepository';
import { PlansAndPurchaseTabDataProviderFactory } from '../factory/PlansAndPurchaseTabDataProviderFactory';
import { PlansAndPurchaseTabBaseDataProvider } from '../dataProvider/PlansAndPurchaseTabBaseDataProvider';
import {
  GetExtendSeatsPriceFunction,
  GetExtendSeatsUrlFunction,
  GetPlansAndPurchaseDataResponse,
  GetRenewalUrlFunction,
} from '../types/types';

export class PlansAndPurchaseTabRepository extends BaseWebComponentRepository {
  public dataProviderFactory: PlansAndPurchaseTabDataProviderFactory;
  public dataProvider: PlansAndPurchaseTabBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new PlansAndPurchaseTabDataProviderFactory(),
    });
  }

  public async getPlansAndPurchaseData(): Promise<GetPlansAndPurchaseDataResponse> {
    return await this.dataProvider.getPlansAndPurchaseData();
  }

  public async getExtendSeatsPrice(
    licenseKey: string,
    seatsCount: number
  ): Promise<ReturnType<GetExtendSeatsPriceFunction>> {
    return await this.dataProvider.getExtendSeatsPrice(licenseKey, seatsCount);
  }

  public async getExtendSeatsUrl(
    licenseKey: string,
    seatsCount: number
  ): Promise<ReturnType<GetExtendSeatsUrlFunction>> {
    return await this.dataProvider.getExtendSeatsUrl(licenseKey, seatsCount);
  }

  public async getRenewalUrl(licenseKey: string): Promise<ReturnType<GetRenewalUrlFunction>> {
    return await this.dataProvider.getRenewalUrl(licenseKey);
  }
}
